// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lbxP","question":"styles_question__2QtDP","description":"styles_description__2rFfz"};